__turbopack_context__.v({
  "cardImage": "QItO9q_cardImage",
  "cardOverlay": "QItO9q_cardOverlay",
  "cardTitle": "QItO9q_cardTitle",
  "exploreCard": "QItO9q_exploreCard",
  "exploreIcon": "QItO9q_exploreIcon",
  "exploreText": "QItO9q_exploreText",
  "gridContainer": "QItO9q_gridContainer",
  "imageCard": "QItO9q_imageCard",
  "sectionContainer": "QItO9q_sectionContainer",
});
